import React from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.error.main,
    textTransform: "inherit",
    fontSize: "1rem",
  },
}));

import Typography from "@material-ui/core/Typography";

const ErrorMessage = (props) => {
  const { t } = useTranslation();
  const { message } = props;
  const classes = useStyles();

  return message ? (
    <Typography className={classes.root} variant="subtitle1">
      {t(message)}
    </Typography>
  ) : null;
};
ErrorMessage.propTypes = {
  message: PropTypes.any,
};

export default ErrorMessage;
